import { Card, Row } from 'antd';
import styled from 'styled-components';
 

export const StyledBackground = styled(Row)`
  min-height: 100vh; /* Full height of the viewport */
 
  display: flex;
  
  justify-content: center; /* Centers horizontally */
  align-items: center; /* Centers vertically */
  background-position: center center;
  background-size: cover;
  background-image: url('/login_bg.jpg'); 
`;

export const StyledCard = styled(Card)`
  padding: 16px;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

export const StyledRow = styled(Row)`
  margin-bottom: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
`;
